import getPrices from './get-prices';
import setPrices from './set-prices';
import getDomains from './get-domains';
import setDomains from './set-domains';
import getTldCollection from './get-tld-collection';
import setTldCollection from './set-tld-collection';
import setInputValue from './set-input-value';
import setAutocompleteData from './set-autocomplete-data';
import validateValue from './validate-value';

export default {
  getPrices,
  setPrices,
  getDomains,
  setDomains,
  getTldCollection,
  setTldCollection,
  setInputValue,
  setAutocompleteData,
  validateValue,
};
